import { Paths, PathValue } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Flex, Paper, Radio, Stack, Text, Title, Box } from "@mantine/core";
import {
  IGKMaalingAvArbeidstrykkOgKontrollAvInternTrykkmaalerResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import { beregnetDiffMellomToVerdier } from "../gkGlobalUtils";
const MaalingAvDriftstrykk: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvArbeidstrykkOgKontrollAvInternTrykkmaalerResultater;
}> = ({ data, onUpdateEditData }) => {
  useEffect(() => {
    utdataBeregninger();
  }, [
    data.inndata.avlestTrykkHovedkammer,
    data.inndata.maaltTrykkHovedkammer,
    data.inndata.maaltInterntrykkHoeyreSluse,
    data.inndata.avlestInterntrykkHoeyreSluse,
    data.inndata.maaltInterntrykkVenstreSluse,
    data.inndata.avlestInterntrykkVenstreSluse,
    data.inndata.maaltInterntrykkHovedfilter,
    data.inndata.avlestInterntrykkHovedfilter,
  ]);
  const utdataBeregninger = () => {
    const trykkDiffHovedkammer = beregnetDiffMellomToVerdier(
      data.inndata.maaltTrykkHovedkammer,
      data.inndata.avlestTrykkHovedkammer,
    );
    const trykkDiffHoeyreSluse = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkHoeyreSluse,
      data.inndata.avlestInterntrykkHoeyreSluse,
    );
    const trykkDiffVenstreSluse = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkVenstreSluse,
      data.inndata.avlestInterntrykkVenstreSluse,
    );
    const trykkDiffHovedfilter = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkHovedfilter,
      data.inndata.avlestInterntrykkHovedfilter,
    );
    const utdata = {
      trykkDiffHovedkammer: trykkDiffHovedkammer,
      trykkDiffHoeyreSluse: trykkDiffHoeyreSluse,
      trykkDiffVenstreSluse: trykkDiffVenstreSluse,
      trykkDiffHovedfilter: trykkDiffHovedfilter,
    };
    onUpdateEditData("testResultater.maalingAvDriftstrykk.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Måling av interntrykk
        </Title>
        <div>
          <div style={{ marginTop: 0, display: "flex", flexDirection: "column" }}>
            <Title order={5} mb={0}>
              Hovedkammer:
            </Title>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestTrykkHovedkammer}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestTrykkHovedkammer",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </div>
          <Flex direction="column" mt="sm">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltTrykkHovedkammer}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltTrykkHovedkammer",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </Flex>
          <Flex justify="space-between">
            <Text mb={0}>
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestTrykkHovedkammer,
                  data.inndata.maaltTrykkHovedkammer,
                )?.toFixed(2) ?? ""}
              </b>
            </Text>
            <Text mb={0}>Formel: &#40;Pd = Pm - Pa&#41;</Text>
          </Flex>
        </div>
        <hr style={{ marginTop: 0 }} />
        <div>
          <div style={{ marginTop: 0, display: "flex", flexDirection: "column" }}>
            <Title order={5} mb={0}>
              Høyre sluse:
            </Title>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkHoeyreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestInterntrykkHoeyreSluse",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </div>
          <Flex direction="column" mt="sm">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkHoeyreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltInterntrykkHoeyreSluse",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </Flex>
          <Flex justify="space-between">
            <Text mb={0}>
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkHoeyreSluse,
                  data.inndata.maaltInterntrykkHoeyreSluse,
                )?.toFixed(2) ?? ""}
              </b>
            </Text>
            <Text mb={0}>Formel: &#40;Pd = Pm - Pa&#41;</Text>
          </Flex>
        </div>
        <hr style={{ marginTop: 0 }} />
        <div>
          <div style={{ marginTop: 0, display: "flex", flexDirection: "column" }}>
            <Title order={5} mb={0}>
              Venstre sluse:
            </Title>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkVenstreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestInterntrykkVenstreSluse",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </div>
          <Flex direction="column" mt="sm">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkVenstreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltInterntrykkVenstreSluse",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </Flex>
          <Flex justify="space-between">
            <Text mb={0}>
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkVenstreSluse,
                  data.inndata.maaltInterntrykkVenstreSluse,
                )?.toFixed(2) ?? ""}
              </b>
            </Text>
            <Text mb={0}>Formel: &#40;Pd = Pm - Pa&#41;</Text>
          </Flex>
        </div>
        <hr style={{ marginTop: 0 }} />
        <div>
          <div style={{ marginTop: 0, display: "flex", flexDirection: "column" }}>
            <Title order={5} mb={0}>
              Hovedfilter:
            </Title>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkHovedfilter}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.avlestInterntrykkHovedfilter",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </div>
          <Flex direction="column" mt="sm">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkHovedfilter}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvDriftstrykk.inndata.maaltInterntrykkHovedfilter",
                  Number(e.target.value),
                )
              }
              style={{ width: "25%" }}
            />
          </Flex>
          <Flex justify="space-between">
            <Text mb={0}>
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkHovedfilter,
                  data.inndata.maaltInterntrykkHovedfilter,
                )?.toFixed(2) ?? ""}
              </b>
            </Text>
            <Text mb={0}>Formel: &#40;Pd = Pm - Pa&#41;</Text>
          </Flex>
        </div>
        <hr style={{ marginTop: 0 }} />
        <div>
          <Title order={5} mb={0}>
            I henhold til fabrikantens spesifikasjoner?
          </Title>
          <Stack gap={0}>
            <Radio
              checked={data.inndata.ihenholdTilFabrikant === true}
              onChange={() =>
                onUpdateEditData("testResultater.maalingAvDriftstrykk.inndata.ihenholdTilFabrikant", true)
              }
              label="Godkjent"
            />
            <Radio
              checked={data.inndata.ihenholdTilFabrikant === false}
              onChange={() =>
                onUpdateEditData("testResultater.maalingAvDriftstrykk.inndata.ihenholdTilFabrikant", false)
              }
              label="Ikke godkjent"
            />
          </Stack>
        </div>
        <Box mt="lg" style={{ width: "50%" }}>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.maalingAvDriftstrykk.inndata.kommentar", e.target.value)}
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default MaalingAvDriftstrykk;
